export default __webpack_public_path__ + "static/media/icon-flag-reg.63ccdc18.svg";